export const execed = {
  lse: {
    pre: {
      sourceKey: "src_2gYLRgHjFpYNtzQNURsiKeoBaZH",
      writeKey: "wk_2gYLRd7jRmu6Zg2mk6I4keLarRp",
      oneTrust: "0192299e-340f-7626-98f0-0ca336de5ffa",
    },
    ppa: {
      sourceKey: "src_2gYLLpyxRMPrp3nCPDmDpi7GbCa",
      writeKey: "wk_2gYLLlYwbsQoX7K774aJjkwJLYT",
      oneTrust: "0192299e-340f-7626-98f0-0ca336de5ffa",
    },
    ref: {
      sourceKey: "src_2gYLJ3DYPHKLV0QPFKm5ruAFpfX",
      writeKey: "wk_2gYLJ2XEoaUx4QhvpEOPuzxXQ7p",
      oneTrust: "0192299e-340f-7626-98f0-0ca336de5ffa",
    },
    dam: {
      sourceKey: "src_2gYLG5vlQw2UqxCEqLGPDG1Fb8O",
      writeKey: "wk_2gYLG6YUhbXoHhRWdX8fJdKPQZ7",
      oneTrust: "0192299e-340f-7626-98f0-0ca336de5ffa",
    },
    etai: {
      sourceKey: "src_2hQ1oHYwnVsu6HcN2lTm5brusHi",
      writeKey: "wk_2hQ1oHkgfsH0RZcsGj3CiPvctRO",
      oneTrust: "0192299e-340f-7626-98f0-0ca336de5ffa",
    },
    lpg: {
      sourceKey: "src_2vUx6Jj9dD20jZ6mixSZ3Ejnllj",
      writeKey: "wk_2vUx6JWijSn07ALYNb7eq2czKT0",
      oneTrust: "0192299e-340f-7626-98f0-0ca336de5ffa",
    },
  },
  oxf: {
    lsc: {
      sourceKey: "src_2gYLDG9sevHBv4SEoJYqJcrnRcs",
      writeKey: "wk_2gYLDG4IuAmtFX1wDoUtQRs5tw1",
      oneTrust: "0191e763-220d-73a7-9282-69cf0894efc9",
    },
    osleps: {
      sourceKey: "src_2rzg0USgXzrnTS5SY7v8YRkNbYa",
      writeKey: "wk_2rzg0ThgeseDtcWnvWWEdMIzI4w",
      oneTrust: "0191e763-220d-73a7-9282-69cf0894efc9",
    },
  },
  mit: {
    ai: {
      sourceKey: "src_2f0dxW6l86JNhhUH1rPzQFW2obA",
      writeKey: "wk_2f0dxWg9p66P0Rlfo7bgCm3SjcR",
      oneTrust: "0191dd4f-c7be-74fd-9889-3d9436d1d870",
    },
    ahc: {
      sourceKey: "src_2hQ1MXHXxy5ryjKSebiV3Gj7khh",
      writeKey: "wk_2hQ1MXcgOTb720PcMvAERxCm3MB",
      oneTrust: "0191dd4f-c7be-74fd-9889-3d9436d1d870",
    },
    aph: {
      sourceKey: "src_2hQ1rluK4SHODOoSCk860qlbNu3",
      writeKey: "wk_2hQ1rlXPA2sxk5OiZBYVnsUvJap",
      oneTrust: "0191dd4f-c7be-74fd-9889-3d9436d1d870",
    },
    nur: {
      sourceKey: "src_2mLKt3EwjOOzqAnytmhOX3NyTNN",
      writeKey: "wk_2mLKt2m57wZ3rIxNzmiQQ0Unmvq",
      oneTrust: "0191dd4f-c7be-74fd-9889-3d9436d1d870",
    },
    ptd: {
      sourceKey: "src_2rzg4NklDIJckcM931X9Arq1P4k",
      writeKey: "wk_2rzg4SL7XuZ0wyLljFCUfSU6c7Q",
      oneTrust: "0191dd4f-c7be-74fd-9889-3d9436d1d870",
    },
  },
  camb: {
    bsm: {
      sourceKey: "src_2hQ1IlNROoU6RNIrYnXw5vZTUJy",
      writeKey: "wk_2hQ1Ip4YhPINXjHPrMkZOqm7uI4",
      oneTrust: "01922070-dde6-7a02-9c55-732e94bd6dbe",
    },
  },
  harv: {
    bok: {
      sourceKey: "src_2mL09Yua8DWnPHnqoQsYydOyjiQ",
      writeKey: "wk_2mL09UKgmInGGDp0Q24ycvj3OhQ",
      oneTrust: "019301ec-e71b-73bb-b18c-c4aa76a036fc",
    },
    cyb: {
      sourceKey: "src_2mL0JCaAbcFKlqTY7ChlubclKs3",
      writeKey: "wk_2mL0JE6Bj6oSVlDG34Fecs0xDwW",
      oneTrust: "019301ec-e71b-73bb-b18c-c4aa76a036fc",
    },
    fih: {
      sourceKey: "src_2mL0PgBEOeCew382FEPZKM9mABH",
      writeKey: "wk_2mL0PgMFJ5LD32rtpYOo3DhclEo",
      oneTrust: "019301ec-e71b-73bb-b18c-c4aa76a036fc",
    },
  },
  stan: {
    nut: {
      sourceKey: "src_2mLLP6bcov7xRyNvBENZHeu2dWA",
      writeKey: "wk_2mLLP6oMNJtBHXWA3ySJm9CXNbW",
      oneTrust: "019363fa-60c6-721b-8f28-f84a8cc05387",
    },
  },
  uct: {
    da: {
      sourceKey: "src_2rs0AvvDeBfV7CPQj49v1HegFmO",
      writeKey: "wk_2rs0ArsqeJTdAIKP6xBxWqcaJww",
      oneTrust: "0194a89d-ad0d-7df5-b985-6992445a689f",
    },
    apm: {
      sourceKey: "src_2vu9BMQk3bcVqxk9WiIxpn2EI7E",
      writeKey: "wk_2vu9BSrb1SL83tYuVCazRfwI8MD",
      oneTrust: "0194a89d-ad0d-7df5-b985-6992445a689f",
    },
    pm: {
      sourceKey: "src_2vu9G3XXMEr8AgP06kLTptX41Y2",
      writeKey: "wk_2vu9G25nxyAtEVlpE6WxZGkr92A",
      oneTrust: "0194a89d-ad0d-7df5-b985-6992445a689f",
    },
  },
  yale: {
    wlp: {
      sourceKey: "src_2mLOfgTpr3rrbxOJ68O4fajD3a7",
      writeKey: "wk_2mLOfkdPeeknE0nh9jTv5WFt5Iv",
      oneTrust: "01936400-e0fe-73b3-9ec4-500afb3b7be2",
    },
  },
};
